import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Button } from './Button'

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode
  size?: 'sm' | 'md'
}

export function IconButton({ icon, size, ...props }: IconButtonProps) {
  return <Button variant="icon" size={size} aria-label={props['aria-label']} title={props.title} {...props} icon={icon} />
}
